import React from 'react';

const FacebookIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 10.0611C20 4.50452 15.5229 0 10 0C4.47715 0 0 4.50452 0 10.0611C0 15.083 3.65686 19.2453 8.4375 20V12.9694H5.89844V10.0611H8.4375V7.84455C8.4375 5.32297 9.93043 3.93013 12.2146 3.93013C13.3087 3.93013 14.4531 4.12664 14.4531 4.12664V6.60263H13.1921C11.9499 6.60263 11.5625 7.37818 11.5625 8.17383V10.0611H14.3359L13.8926 12.9694H11.5625V20C16.3431 19.2453 20 15.083 20 10.0611Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FacebookIcon;
